import React, { Component } from 'react';
import classes from './BSGrid.css';
import PropTypes from 'prop-types';

class BSGrid extends Component {
    render() {
        const {
            wideImage,
            tallImage,
            squaredImage1,
            squaredImage2,
            alt,
            children
        } = this.props;

        const gridClasses = [];

        gridClasses.push(children ? classes.BSGridHeader : classes.BSGrid);

        if (alt) {
            gridClasses.push(classes.Alt);
        }

        return (
            <div className={gridClasses.join(' ')}>
                <div className={classes.Wide}>
                    <img src={wideImage} alt="" className="img-fluid" />
                </div>
                <div className={classes.Tall}>
                    <img src={tallImage} alt="" className="img-fluid" />
                </div>
                <div className={classes.Squared1}>
                    <img src={squaredImage1} alt="" className="img-fluid" />
                </div>
                <div className={classes.Squared2}>
                    {children ? (
                        <div className={classes.TextFrame}>{children}</div>
                    ) : (
                        <img src={squaredImage2} alt="" className="img-fluid" />
                    )}
                </div>
            </div>
        );
    }
}

BSGrid.propTypes = {
    wideImage: PropTypes.string.isRequired,
    tallImage: PropTypes.string.isRequired,
    squaredImage1: PropTypes.string.isRequired,
    squaredImage2: PropTypes.string,
    children: PropTypes.node
};

export default BSGrid;



// WEBPACK FOOTER //
// ./src/components/BSGrid/BSGrid.js